import DocumentTitle from "react-document-title";
import { Link } from "react-router-dom";
import InnerLoginView from "./InnerLoginView";
import React from "react";

function AwsMarketplace() {
  return (
    <DocumentTitle title="Upsolver">
      <div className="marketplace">
        <h1>Marketplace Integration</h1>
        <div className="box">
          <div>
            <h2>Create a new account</h2>
            <Link to="signup" className="primary-button">
              Create Account
            </Link>
          </div>
          <div className="separator">
            <div className="line" />
            <span>or</span>
            <div className="line" />
          </div>
          <div>
            <h2>Log in to integrate with your existing account</h2>
            <InnerLoginView />
          </div>
        </div>
      </div>
    </DocumentTitle>
  );
}

export default AwsMarketplace;
